import { render, staticRenderFns } from "./UserDetailHeaderBar.vue?vue&type=template&id=b042a09e&scoped=true"
import script from "./UserDetailHeaderBar.vue?vue&type=script&lang=js"
export * from "./UserDetailHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./UserDetailHeaderBar.vue?vue&type=style&index=0&id=b042a09e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b042a09e",
  null
  
)

export default component.exports